import React, { lazy, Suspense, useEffect, useState } from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "routes.js";
// Components used directly in this layout's hardcoded routes are already
// lazy-loaded via routes.js — no separate static imports needed.
import AdsSection from "components/AdsSection";
import cross from "../assets/img/cross.svg";
import { fetchCoinsLimit } from "store/actions/walletAction";
import { useDispatch, useSelector } from "react-redux";
const Admin = (props) => {
  const { limitExceeded } = useSelector((state) => state.wallet);
  const dispatch = useDispatch();
  const mainContent = React.useRef(null);
  const location = useLocation();
  const [showAds, setShowAds] = useState(false);
  const switchAdds = () => {
    setShowAds(!showAds);
  };
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/fan") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        props.location.pathname.indexOf(routes[i].layout + routes[i].path) !==
        -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };

  useEffect(() => {
    // Temporarily disabled - endpoint returning 503
    // TODO: Re-enable when backend /check-disbursement-limit endpoint is fixed
    // dispatch(fetchCoinsLimit());
  }, []);

  return (
    <>
      {limitExceeded && (
        <div
          className="bg-danger position-fixed w-100 text-center text-white"
          style={{ height: "30px", zIndex: "999" }}
        >
          {" "}
          The Maximum Coins Limit has been reached for this year.
        </div>
      )}
      <Sidebar
        {...props}
        routes={routes}
        logo={{
          innerLink: "/fan/instructions-read-first",
          imgSrc: require("../assets/img/brand/argon-react.png").default,
          imgAlt: "...",
        }}
        maxLimitReached={limitExceeded}
      />
      <div className="main-content main-content-fan" ref={mainContent}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props.location.pathname)}
          maxLimitReached={limitExceeded}
        />
        <div className="text-right mt-2 d-lg-none">
          <h3 onClick={switchAdds} className="mr-3">
            Show Ads
          </h3>
        </div>
        <Switch>
          <Suspense fallback={<div className="text-center mt-5">Loading…</div>}>
          {getRoutes(routes)}
          <Redirect from="*" to="/fan/instructions-read-first" />
          </Suspense>
        </Switch>
        <div className={`ads d-lg-none `}>
          <div
            id="ads"
            className={`d-lg-none p-2 ads_div ${showAds ? "show" : "hide"}`}
          >
            <img src={cross} width={20} alt="" onClick={switchAdds} />
            <AdsSection />
          </div>
        </div>
      </div>
      <div className="ads d-none d-lg-block">
        <div
          className="p-2 ads_div "
          style={{ top: limitExceeded ? "111px" : "81px" }}
        >
          <AdsSection />
        </div>
      </div>
    </>
  );
};

export default Admin;
